import { render, staticRenderFns } from "./HabilityTypeAddEdit.vue?vue&type=template&id=31ed434a"
import script from "./HabilityTypeAddEdit.vue?vue&type=script&lang=js"
export * from "./HabilityTypeAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports